import { Auth0Provider } from '@auth0/auth0-react';
import React, { ReactNode, useEffect } from 'react';
import { getConfig } from '../../utils/Auth0Utils';
import { useHistory, useLocation } from 'react-router';
import { getUserTypeFromURL } from '../../utils/HistoryUtils';
import { CURRENT_ENV_ROLE_TYPE } from '../../utils/EnvConfigUtils';

interface SSOProviderProps {
	children: ReactNode;
}

const SSOProvider: React.FC<SSOProviderProps> = ({ children }) => {
	const history = useHistory();
	const location = useLocation();

	const onRedirectCallback = (appState) => {
		history.push((appState && appState.returnTo) || window.location.pathname);
	};
	const userType = getUserTypeFromURL(location) || CURRENT_ENV_ROLE_TYPE;

	const config = getConfig(userType);

	const providerConfig = {
		domain: config.domain,
		clientId: config.clientId,
		onRedirectCallback,
		authorizationParams: {
			redirect_uri: `${window.location.origin}/${userType}/login`,
			...(config.audience ? { audience: config.audience } : null),
		},
	};

	return <Auth0Provider {...providerConfig}>{children}</Auth0Provider>;
};

export default SSOProvider;
